<!--  -->
<template>
  <div class="contaniner">
    <banner :type="type" :poster="poster"></banner>
    <div class="news-page-box">
      <news-head :title="title"></news-head>
      <div class="content-box">
        <div class="news-wrapper" v-for="(item, index) in listInfo">
          <span @click="toNewsContent(item.owNewsId)" class="news-title">{{
            item.title
          }}</span>
          <span class="time">{{ item.lastOnlineTime }}</span>
        </div>
      </div>
      <div class="paging">
        <pagination :pageInfo="pageInfo" @change="pagechange"></pagination>
      </div>
    </div>
    <msg-box></msg-box>
    <top-arrow></top-arrow>
    <moni-footer></moni-footer>
  </div>
</template>

<script>
import banner from "../../components/banner/banner";
import NewsHead from "../../components/header/head";
import pagination from "../../components/pagination/pagination";
import msgBox from "../../components/msgBox/msgBox";
import topArrow from "../../components/topArrow/topArrow";
import moniFooter from "../../components/moniFooter/moniFooter";
import http from "../../api/http.js";
import apiUrl from "../../api/apiUrl.js";
import util from "../../api/util.js";
import "jquery";

export default {
  name: "newsPage",
  data() {
    return {
      type: "poster",
      poster: require("../../assets/images/banner5.png"),
      title: "新闻中心",
      listInfo: [],
      pageInfo: {
        total: 0, // 记录总条数   默认空，如果小于pageNum则组件不显示
        current: 1, // 当前页数，   默认为1
        pagenum: 6, // 每页显示条数,默认10
        pagegroup: 5, // 分页条数     默认为5，需传入奇数
        skin: "#FBABC7" // 选中页码的颜色主题 默认为'#16a086'
      }
    };
  },

  props: [],

  watch: {},

  components: {
    banner,
    NewsHead,
    pagination,
    moniFooter,
    msgBox,
    topArrow
  },

  computed: {},

  created() {
    const pageNum = this.pageInfo.pagenum;
    this.pageInfo.total = this.listInfo.length;
    this.fetchNewsInfo(1, pageNum);
    $("html,body").animate({ scrollTop: 0 }, 500);
  },

  methods: {
    pagechange(current) {
      this.fetchNewsInfo(current, this.pageInfo.pagenum);
    },
    fetchNewsInfo(current, num) {
      http
        .get(apiUrl.newsListInfo + "/" + current + "/" + num)
        .then(response => {
          console.log(response);
          if (response.code == 0) {
            const data = response.data;
            this.pageInfo.total = data.total;
            this.listInfo = data.list;
            for (let i = 0; i < data.list.length; i++) {
              data.list[i].lastOnlineTime = util.formatTime(
                data.list[i].lastOnlineTime,
                "date"
              );
            }
          }
        });
    },
    toNewsContent(id) {
      this.$router.push({
        name: "NewsPage",
        query: { newsId: id },
        force: true
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.contaniner {
  .news-page-box {
    width: 100%;
    min-height: 870px;
    padding: 80px 350px 185px 350px;
    box-sizing: border-box;
    font-size: 20px;
    position: relative;
    .content-box {
      margin-top: 30px;
      .news-wrapper {
        font-size: 20px;
        line-height: 28px;
        width: 100%;
        height: 90px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: #999 dashed 1px;
        .news-title {
          display: inline-block;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          width: 100%;
          text-align: left;
          cursor: pointer;
        }
        .news-title:hover {
          color: #ed4e7f;
        }
        .time {
        }
      }
    }
    .paging {
      position: absolute;
      right: 350px;
      bottom: 50px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newsCenter/newsCenter.vue